import type { InjectionKey } from 'vue'
import type { IDescriptionsInject } from './descriptions.type'

export const descriptionsKey =
  'bDescriptions' as any as InjectionKey<IDescriptionsInject>
